function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import followbrand from './followbrand.json';
import LottieAnimation from '../LottieAnimation';

const FollowBrand = ({ ...props
}) => /*#__PURE__*/React.createElement(LottieAnimation, _extends({
  icon: followbrand,
  ariaLabel: "brand volgen icoon"
}, props));

export default FollowBrand;